import { getInitData } from './telegram';

// Пусто по умолчанию = запросы идут на тот же origin, откуда открыт фронт,
// а Vite dev-сервер (см. vite.config.ts proxy) сам перенаправляет /api и /socket.io на backend.
// Это позволяет обойтись ОДНИМ cloudflared-туннелем вместо двух.
export const API_BASE = import.meta.env.VITE_API_URL ?? '';

async function request<T>(path: string, options: RequestInit = {}, token?: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `Ошибка запроса: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function loginWithTelegram() {
  const initData = getInitData();
  return request<{ token: string; profile: any }>('/api/auth/telegram', {
    method: 'POST',
    body: JSON.stringify({ initData }),
  });
}

export function fetchLobbyTables(token: string) {
  return request<{ tables: any[] }>('/api/tables', {}, token);
}

export function fetchProfile(token: string) {
  return request('/api/profile/me', {}, token);
}
